import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';
import {ZiggyContextProvider} from "./store/ziggy-context";
import ErrorHandler from "./libs/ErrorHandler";
import {GoogleOAuthProvider} from "@react-oauth/google";
import {StyledEngineProvider} from "@mui/material";
import MlibComponents, {initServiceWorker} from "@lb/mlib-components";
import {BrowserRouter} from "react-router";
import {LocationsProvider} from "./libs/locations";

const providers = [
    ErrorHandler,
    (props) => <StyledEngineProvider {...props} injectFirst/>,
    /*
        ({children, ...rest}) => <ThemeProvider {...rest} theme={themeLight}><CssBaseline/>{children}</ThemeProvider>,
    */
    ZiggyContextProvider,
    LocationsProvider,
    MlibComponents,
    ({children, ...rest}) =>
        <GoogleOAuthProvider clientId={'674869190121-bqu1soou4ad2bk4frpbl8olus8bjv29e.apps.googleusercontent.com'}
                             {...rest} children={children}/>
];


function renderApp() {
    let content = <App/>;
    [...providers].reverse().map(Component => content = <Component>{content}</Component>);
    return <BrowserRouter>{content}</BrowserRouter>;
}

// React 18 introduces a new root API which provides better ergonomics for managing roots.
const container = document.getElementById('root');
const root = createRoot(container)
root.render(<React.StrictMode>{renderApp()}</React.StrictMode>)

// ReactDOM.render(renderApp(), document.getElementById('root'));

initServiceWorker();
